<template>
  <transition name="slide-up">
    <div v-if="visible" class="scroll-hint">
      <span>↓ {{ message }}</span>
      <div class="scroll-hint-actions">
        <button class="scroll-hint-btn" @click="onScroll">
          {{ button }}
        </button>
        <button class="scroll-hint-close" @click="dismiss">
          ✕
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ScrollHint',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Neue Berechnungen verfügbar',
    },
    button: {
      type: String,
      default: 'Anzeigen',
    },
    autoDismiss: {
      type: Number,
      default: 8000,
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  watch: {
    visible(val) {
      if (val && this.autoDismiss > 0) {
        this.timer = setTimeout(() => this.dismiss(), this.autoDismiss);
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    onScroll() {
      this.$emit('scroll-to');
      this.dismiss();
    },
    dismiss() {
      clearTimeout(this.timer);
      this.$emit('dismiss');
    },
  },
};
</script>

<style scoped>
.scroll-hint {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: #198754;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 1050;
  display: flex;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
}

.scroll-hint-actions {
  display: flex;
  gap: 8px;
}

.scroll-hint-btn {
  background: white;
  color: #198754;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-weight: bold;
}

.scroll-hint-btn:hover {
  background: #e8f5e9;
}

.scroll-hint-close {
  background: transparent;
  color: white;
  border: 1px solid rgba(255,255,255,0.5);
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
}

.scroll-hint-close:hover {
  background: rgba(255,255,255,0.15);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
